import React, { useEffect, useState } from 'react';
import HorizontalBarChart from '../diagrams/HorizontalBarChart';
import Modal from '../utils/Modal';
import { CountriesDB } from '../db/CountriesDB';
import { Utils } from '../utils/Utils';

function NationalitiesStats(teams) {

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [data, setData] = useState([]);
  const [totalData, setTotalData] = useState([]);

  const getDistinctCountries = async (stats) => {
    const countries = Array.from(new Set(stats.map(stat => stat.nationality)));
    return await CountriesDB.getDistinct(countries)
  }

  

  useEffect(() => {

    const getNationalitiesStats = () => {
      return Array.from(
          teams.teams
            .flatMap(team => team.players)
            .reduce((acc, player) => {
              if (player !== undefined) {
                const keys = [player.nationality, player.nationality2]
                for (const key of keys) {
                  if (key !== "" && key !== undefined) {
                    if (!acc.has(key)) {
                      acc.set(key, {
                        nationality: key,
                        count: 1
                      });
                    } else {
                      acc.get(key).count++;
                    }
                  }
                }
              }
              return acc;
            }, new Map())
          .values()
        ).sort((a, b) => b.count - a.count);
    }
  
    const parseStats = async (stats) => {
      if (stats.length > 0) {
        return await getDistinctCountries(stats).then(countries => {
          return stats.map(stat => ({
            name: Utils.showFlagCountry(countries, stat.nationality, true) + '&nbsp;' + stat.nationality,
            value: stat.count
          }));
        });
      }
    }
  
    parseStats(getNationalitiesStats()).then(stats => {
      setTotalData(stats)
      setData(stats.slice(0,10))
    });
  
  }, [teams.teams]);


  return (
    <div>
      <p><b>Número de nacionalidades</b></p>
      <HorizontalBarChart data={data}/>
      <button className="btn-all-data" onClick={() => setIsModalOpen(true)}>
        Ver todos los datos
      </button>
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <table className="table-stats">
          <thead>
            <tr>
              <th>Nacionalidad</th>
              <th>Nº de jugadores</th>
            </tr>
          </thead>
          <tbody>
          {totalData.map((item, index) => (
            <tr key={index}>
              <td><div className="label-country" dangerouslySetInnerHTML={{ __html: item.name }}></div></td><td className="td-value"> {item.value}</td>
            </tr>
          ))}
          </tbody>
        </table>
      </Modal>
    </div>
  )
}

export default NationalitiesStats